import { combineReducers } from 'redux';
import LoginReducer from './Components/Login/LoginReducer';
import InventoryReducer from './Components/Inventory/InventoryReducer';
import FormReducer from './Components/DynamicForm/FormReducer';
import SamplingReducer from './Components/Sampling/SamplingReducer';
import UserReducer from './Components/Dashboard/UserReducer';
import fileUploadReducer from './Components/FileUpload/fileUploadReducer';
import WorklistingReducer from './Components/WorkListing/WorklistingReducer';
import WebFormReducer from './Components/WebForm/WebFormReducer';
import CSATReducer from './Components/CSAT/CSATReducer';
import ComplianceReducer from './Components/Compliance/complianceReducer';
import agentAuditorReducer from './Components/AgentAuditorMapping/agentAuditorReducer';
import ReportsReducer from './Components/Reports/ReportsReducer';
import dynamicTableReducer from './Components/DynamicTable/dynamicTableReducer';
import manualAssignReducer from './Components/ManualAssign/manualAssignReducer';
// export default combineReducers({
//   LoginReducer,
//   UserReducer,
//   InventoryReducer,
//   FormReducer,
//   SamplingReducer,
//   fileUploadReducer,
//   WorklistingReducer,
//   WebFormReducer,
//   CSATReducer,
//   ComplianceReducer,
//   agentAuditorReducer
// });

const appReducer = combineReducers({
  LoginReducer,
  UserReducer,
  InventoryReducer,
  FormReducer,
  SamplingReducer,
  fileUploadReducer,
  WorklistingReducer,
  WebFormReducer,
  CSATReducer,
  ComplianceReducer,
  agentAuditorReducer,
  ReportsReducer,
  dynamicTableReducer,
  manualAssignReducer
});

const rootReducer = (state, action) => {  
  if (action.type === 'LOG_OUT') {
    state = undefined;
  }

  return appReducer(state, action);
}

export default rootReducer;